export default __webpack_public_path__ + "static/media/icon-twitter.ea5fe387.svg";